import { ApiRequest, PagedList } from 'framework/api';

import { UrlBuilder } from 'tools';
import { RulesConfiguration } from 'controls/queryBuilder/ruleDefinition';
import { GridDataItem } from 'controls/grid/gridDataItem';
import { DataSource } from 'areas/data-sources/types/dataSource';

type GetDataSourcesArgs = {
	accountId?: string;
	dataSourceSelectorAccountId?: string | null;
};

export const getDataSourcePayload = (args: GetDatasourceFiltersConfigurationArgs) => ({
	pivotData: args.pivotData,
	pivotMatrix: args.pivotMatrix,
	pivotColumns: args.pivotColumns,
	pivotRows: args.pivotRows,
	pivotValues: args.pivotValues,
	categoryColumns: args.categoryColumns,
	dataColumns: args.dataColumns,
	dataRows: args.dataRows,
	requestId: args.requestId,
	splitPivotValues: args.splitPivotValues,
});

export function getDataSources(args: GetDataSourcesArgs) {
	const urlBuilder = new UrlBuilder('dataSources');
	if (args?.dataSourceSelectorAccountId === null) {
		urlBuilder.add('shared', 'true');
	}
	return new ApiRequest<DataSource[]>({
		url: urlBuilder.build(),
		accountBased: true,
		accountId: args?.dataSourceSelectorAccountId || args?.accountId,
	});
}

export type GetDatasourceFiltersConfigurationArgs = {
	accountId: string;
	dataSourceId: string;
	categoryColumns?: string[];
	dataColumns?: string[];
	dataRows?: string[];
	pivotData?: boolean;
	pivotMatrix?: boolean;
	splitPivotValues?: boolean;
	pivotColumns?: string[];
	pivotRows?: string[];
	pivotValues?: string[];
	requestId: string;
};

export function getDataSourceFiltersForPivotConfiguration(args: GetDatasourceFiltersConfigurationArgs) {
	const urlBuilder = new UrlBuilder(`dataSources/${args.dataSourceId}/ruleConfiguration`);
	return new ApiRequest<RulesConfiguration>({
		url: urlBuilder.build(),
		accountId: args.accountId,
		accountBased: true,
		method: 'POST',
		payload: {
			categoryColumns: args.categoryColumns,
			requestId: args.requestId,
		},
	});
}

export function getDataSourceFiltersConfiguration(args: GetDatasourceFiltersConfigurationArgs) {
	const urlBuilder = new UrlBuilder(`dataSources/${args.dataSourceId}/ruleConfiguration`);
	return new ApiRequest<RulesConfiguration>({
		url: urlBuilder.build(),
		accountId: args.accountId,
		accountBased: true,
		method: 'POST',
		payload: getDataSourcePayload(args),
	});
}

export type DataSourceDataItem = {
	[key: string]: string | number;
};

export function getDataSourceData(args: GetDatasourceFiltersConfigurationArgs) {
	return new ApiRequest<PagedList<GridDataItem<DataSourceDataItem>>>({
		url: `dataSources/${args.dataSourceId}/data`,
		accountBased: true,
		accountId: args.accountId,
		method: 'POST',
		payload: getDataSourcePayload(args),
	});
}

export type ClearDatasourceCacheArgs = {
	accountId: string;
	requestId: string;
};

export function clearDatasourceCache(args: ClearDatasourceCacheArgs) {
	return new ApiRequest<RulesConfiguration>({
		url: `dataSources/release/${args.requestId}`,
		accountId: args.accountId,
		accountBased: true,
		method: 'GET',
	});
}
